import { useEffect, useRef } from "react"
import { useHistory, withRouter } from "react-router"
import io from "socket.io-client"

const RouteBroadcaster = props => {
  const {
    location: { pathname }
  } = props

  const socket = useRef()
  const history = useHistory()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  useEffect(() => {
    socket.current = io(url)
    if (role === "sender") {
      document.addEventListener(
        "scroll",
        e => {
          socket.current.emit("scroll", [
            e.target.className,
            e.target.scrollLeft,
            e.target.scrollTop
          ])
        },
        true
      )
    }
    if (role === "recipient") {
      socket.current.on("scroll", data => {
        const element = document.querySelector(`.${data[0]}`)
        if (element) {
          element.scrollTo({
            top: data[2],
            left: data[1],
            behavior: "smooth"
          })
        }
      })
    }
  }, [url, role])

  useEffect(() => {
    socket.current.emit("subscribe-navigation", 1000)
    if (role === "recipient") {
      socket.current.on("navigation", path => {
        if (path !== window.location.pathname) history.push(path)
      })
    }
    return () => socket.current.close()
  }, [history, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("navigation", pathname)
    }
  }, [pathname, role])

  return null
}

export default withRouter(RouteBroadcaster)
